const CONTRACT_DOCUMENT_LIST_TAG_NAME = 'Mietvertrag'

const fetchContractDocumentsPage = async (token, queryParams) => {
  const params = new URLSearchParams({
    order: 'DESC',
    sort: 'updated',
    size: '30',
    ...queryParams,
  })
  const res = await fetch(`/services/pmp-document/api/v1/documents?${params.toString()}`, {
    headers: { Authorization: 'Bearer ' + token },
  })
  if (!res.ok) throw new Error('Documents fetch failed')
  return res.json()
}

const fetchContractDocumentsForContract = async (contractId, token, options = {}) => {
  if (contractId == null || !token) return []

  const fetchPage = options.fetchPage || fetchContractDocumentsPage
  const pageQuery = {
    tagName: CONTRACT_DOCUMENT_LIST_TAG_NAME,
    contractId: String(contractId),
  }

  const firstPage = await fetchPage(token, { page: '0', ...pageQuery })
  const all = [...(firstPage.content || [])]
  if (all.length === 0) return []

  let page = 1
  let totalPages = firstPage.totalPages != null ? firstPage.totalPages : 1
  while (page < totalPages) {
    const data = await fetchPage(token, { page: String(page), ...pageQuery })
    all.push(...(data.content || []))
    totalPages = data.totalPages != null ? data.totalPages : 1
    page++
  }

  return all
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    CONTRACT_DOCUMENT_LIST_TAG_NAME,
    fetchContractDocumentsPage,
    fetchContractDocumentsForContract,
  }
}
